import React from 'react';
import api from '../../lib/MentalApi';
import Spinner from '../Spinner';
import Error from '../Error';
import RNIntegration from '../../lib/RNIntegration';

type Props = {
    children: React.ReactNode,
};

type LoadingState = 'NotStarted' | 'Loading' | 'Loaded' | 'Error';

type State = {
    loadingState: LoadingState,
};

export default class ApiLoadingWrapper extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            loadingState: 'NotStarted',
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const { loadingState } = this.state;
        if (loadingState === 'Loading') return;
        this.setState({ loadingState: 'Loading' });

        const success = await api.loadData();

        if (success) {
            RNIntegration.notifyUserUpdate();
            this.setState({ loadingState: 'Loaded' });
        } else {
            this.setState({ loadingState: 'Error' });
        }
    }

    render() {
        const { loadingState } = this.state;

        if (loadingState === 'NotStarted' || loadingState === 'Loading') {
            return (<Spinner />);
        }

        if (loadingState === 'Error') {
            return (
                <Error
                    title="Daten konnten nicht geladen werden"
                    detail="Es konnte leider keine Verbindung mit eleMental hergestellt werden"
                    actions={{ 'Erneut versuchen': () => this.loadData() }}
                />
            );
        }

        const { children } = this.props;

        return (
            <>
                {children}
            </>
        );
    }
}
